export const environment = {
  production: false,
  apiBaseURL:'/api',
  siteBaseURL:"",
  localMode:false,
  siteName:'SSC AI Translation',
  loginPublicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1Aa69sucsZv5rcx7cmUT
udHO8M6dsX3XYHsDIbNMRo7MrpZP7MChUzhDocDhnb/gYWUNvXBiLeoNJ+ZeEcvK
jUQy7au216cvKb/Z6108xnK+/icupdEoJyQPT4Glph4il1dZO4+LL3HA4HKCVYDe
0ZXks/9/YI9fteygsFvBtB5YS1YNXfWa6kxe15VZP2EM+DH7SSU+oCpFft/oWLtc
ApM1sdK8A74PdL5dDXgxnp/OId9aoI9BuzQw9Ky2opLK2Gx6ekJ+263+sG8xoJRK
ozoKWYqWI+DsCK86hnkNK7fBXcqAX/Q4ON0j2Jjbm595c8ahBa7rL60IZVgdKTn5
RwIDAQAB
-----END PUBLIC KEY-----`,
};
